import React, {useEffect} from 'react';
import {LoginForm, MainVisual, Footer} from '@components';
import { Link } from 'react-router-dom';
import { AuthHook } from '@hooks';
import { toast } from 'react-toastify';

const Main = () => {
  const { auth, logout } = AuthHook();

  const handleLoginCheck = (e) => {
    if (!auth.isAuthenticated) {
        e.preventDefault();
        toast.warning('로그인이 필요합니다.');
        return;
    }
  };

  const certificationClick = (e) => {
    if (!auth.isAuthenticated) {
        e.preventDefault();
        toast.warning('로그인이 필요합니다.');
      } else if (auth.role !== 'ROLE_USER') {
        e.preventDefault();
        toast.warning('수강생 전용 입니다.');
      }
  };

  const myClassroomLink = () => {
    if (auth.role === 'ROLE_USER') {
      return '/myLectures/myStudentLectures';
    } else {
      return '/main'; 
    }
  };

  // useEffect(() => {
  //   const handleFocus = () => {
  //     const token = localStorage.getItem('jwt');
  //     if (token) {
  //       try {
  //         const { exp } = jwtDecode(token);
  //         if (Date.now() >= exp * 1000) {
  //           logout(true);
  //         }
  //       } catch (error) {
  //         logout(true);
  //       }
  //     }
  //   };
  
  //   window.addEventListener('focus', handleFocus);
  //   return () => window.removeEventListener('focus', handleFocus);
  // }, [logout]);
  


  return (
    <main id="main" className="mainpage">
            <>
            <div className="section main-visual">
                <MainVisual />
            </div>

            <div className="section main-contact">
                <div className="container">
                    <div className="main-BN">
                        <h2>메뉴바로가기</h2>
                        <span>원하시는 곳으로 빠르게 입장 하실 수 있습니다.</span>
                        <div>
                            <ul className="main_banner2">
                                <li className="menu-item"><Link to="/lecture?lectureMethod=집체교육"><b>수강신청</b>원하시는 맞춤수강<br />신청을 해주세요.</Link></li>
                                <li className="menu-item">
                                <Link
                                    to={myClassroomLink()}
                                    onClick={handleLoginCheck}
                                >
                                    <b>나의강의실</b> 수강중인 강의실로 바로 입장 해주세요.
                                </Link>
                                </li>
                                <li className="menu-item">
                                <Link
                                    to="/myLectures/myCompletionStudent"
                                    onClick={certificationClick}
                                >
                                    <b>수료증 확인</b>수강하신 수료증을<br />확인 해주세요.
                                </Link>
                                   
                                </li>
                                <li className="menu-item"><Link to="/support/qna"><b>Q&A</b>궁금하신 사항은<br />문의 해주세요.</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div style={{width: '1280px'}}>
                    <div className="right-content">
                        <div className="catalogue-wrap">
                            <div className="catalogue-content">
                                {!auth.isAuthenticated ? 
                                ( <LoginForm /> ) : 
                                    (
                                    <>
                                    <div className="loginbox mu_member">
                                        <div className="loginForm">
                                            <dl className="inputBox">
                                                <dd>
                                                    <div className="fz35 bold">Welcome</div>
                                                    <div className="id_input_wrap text-cent">
                                                        <div className="fom-item-cent">
                                                            <img className="mr5" src="/img/vip.png" alt="VIP" />
                                                            <span className="fz16 fw500">{auth.name}</span>
                                                        </div>
                                                    </div>
                                                </dd>
                                            </dl>
                                            <Link to={myClassroomLink()} className="btn_login btn_submit btn_color wid  btn-blue"> 나의 강의실</Link>
                                        </div>
                                    </div>	
                                </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
   </main>


  );
};


export default Main;
